import React from 'react';
import { Card, CardContent } from './ui/card';
import { Coins, TrendingUp, ClipboardCheck, Zap } from 'lucide-react';
import { solutionSection } from '../mockData';

const iconMap = {
  Coins: Coins,
  TrendingUp: TrendingUp,
  ClipboardCheck: ClipboardCheck,
  Zap: Zap
};

const SolutionSection = () => {
  return (
    <section className="py-20 bg-emerald-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Title */}
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-emerald-900 text-center mb-16">
          {solutionSection.title}
        </h2>

        {/* Solutions Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-7xl mx-auto">
          {solutionSection.solutions.map((solution) => {
            const IconComponent = iconMap[solution.icon];
            return (
              <Card
                key={solution.id}
                className="group hover:shadow-2xl transition-all duration-300 border-0 overflow-hidden bg-white hover:-translate-y-2"
              >
                {/* Image */}
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={solution.image}
                    alt={solution.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-emerald-900/80 to-transparent"></div>
                  
                  {/* Icon Overlay */}
                  <div className="absolute bottom-4 left-4 bg-amber-500 p-3 rounded-full shadow-lg">
                    <IconComponent className="h-6 w-6 text-emerald-950" />
                  </div>
                </div>

                <CardContent className="p-6">
                  <h3 className="text-xl font-bold text-emerald-900 mb-3 group-hover:text-amber-600 transition-colors duration-300">
                    {solution.title}
                  </h3>
                  <p className="text-emerald-700 leading-relaxed">
                    {solution.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default SolutionSection;